// extracted by mini-css-extract-plugin
export default {"arrow":"scrollButton__arrow-Ih5y3","right":"scrollButton__right-ys0Bb","left":"scrollButton__left-eQNCO","disabled":"scrollButton__disabled-l1DYy"};